console.log("Review Testimonial Slider Script Loaded");

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".review-testimonial-wrapper");
  const slides = document.querySelectorAll(".review-testimonial-slide");
  const prevBtn = document.querySelector(".review-prev-btn");
  const nextBtn = document.querySelector(".review-next-btn");

  if (!wrapper || slides.length === 0) {
    console.error("Review Testimonial Slider elements not found.");
    return;
  }

  let currentIndex = 0;
  const totalSlides = slides.length;

  function updateSlideWidth() {
    let containerWidth = document.querySelector(".review-testimonial-container").clientWidth;

    // Correctly set wrapper width to only fit all slides
    wrapper.style.width = `${totalSlides * containerWidth}px`;

    slides.forEach(slide => {
      slide.style.width = `${containerWidth}px`; // Ensures all slides are full-width
    });

    updateSlidePosition();
  }

  function updateSlidePosition() {
    let slideWidth = document.querySelector(".review-testimonial-container").clientWidth;
    wrapper.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
  }

  prevBtn.addEventListener("click", function () {
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    updateSlidePosition();
  });

  nextBtn.addEventListener("click", function () {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlidePosition();
  });

  // Auto-slide every 5 seconds
  setInterval(() => {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlidePosition();
  }, 10000);

  // Resize listener to fix responsiveness
  window.addEventListener("resize", updateSlideWidth);

  // Initialize
  updateSlideWidth();
});
